module.exports = __webpack_public_path__ + "img/sz_list_banner.07b9fc32.png";